import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getTransactionRegistration(params) {
	return client.get("transaksi/serial/registrasi", {
		params: params,
	});
}

function getTransactionActivation(params) {
	return client.get("transaksi/serial/aktivasi", {
		params: params,
	});
}

function getTransactionUpgrade(params) {
	return client.get("transaksi/serial/upgrade", {
		params: params,
	});
}

function getTransactionRO(params) {
	return client.get("transaksi/serial/repeatorder", {
		params: params,
	});
}

function addTransactionSerial(params) {
	return client.post("transaksi/serial", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getTransactionRegistration,
	getTransactionActivation,
	getTransactionUpgrade,
	getTransactionRO,
	addTransactionSerial,
};